// TODO This page needs to be styled with a theme for all resources

import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Typography, Grid, Box } from '@mui/material';
import { InfoCard } from './components/infoCard';
import resourcesData from './resourcesData.json';
import styles from './resources.module.scss';
import { useCustomTranslation } from '../../translation/customTranslation';

export const Resources = (): JSX.Element => {
  // Getting the path to append to button url
  // as these resources are used in various locations.
  const level = useLocation().pathname.split('/')[1];
  const { t } = useCustomTranslation('resources');
  const navigator = useNavigate();

  const navigateToResources = (item: any) => {
    navigator(`/${level}/${item.buttonUrl}`);
    // Scroll to top as otherwise on mobiles it remains scrolled to bottom
    window.scrollTo(0, 0);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h5" fontWeight="bold">
        {t('concussion.CONCUSSION_RESOURCES_SECTION_TITLE')}
      </Typography>
      {/* <Grid
        container
        spacing={2}
        columns={{ xs: 4, sm: 4, md: 4, lg: 8 }}
        sx={{ p: 1 }}
      >
        {resourcesData.items.map((item) => (
          <Grid xs={2} sm={2} md={4} key={item.title} sx={{ p: 1 }}>
            <InfoCard
              title={t(item.title)}
              headerImage={item.headerImage}
              buttonLabel={t(item.buttonLabel)}
              key={t(item.title)}
            />
          </Grid>
        ))}
      </Grid> */}
      <div className={styles.resourceCardLayout}>
        {resourcesData.items.map((item) => {
          return (
            <Grid
              key={item.title}
              onClick={() => navigateToResources(item)}
              sx={{
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
            >
              <InfoCard
                title={t(item.title)}
                headerImage={item.headerImage}
                buttonLabel={t(item.buttonLabel)}
                key={t(item.title)}
              />
            </Grid>
          );
        })}
      </div>
      <Outlet />
    </Box>
  );
};
